<template>
  <header :class="['navbar', { '--open': isOpen }]">
    <nav class="navbar__top">
      <LangRouterLink :to="{ name: 'home' }" class="navbar__logo" :title="$t('home')">
        <Icon id="logo" />
      </LangRouterLink>
      <TransitionGroup
        name="nav-item-transition"
        tag="div"
        class="navbar__desktop-link-group"
        v-if="mq.mnPlus"
        appear
      >
        <DesktopMenuItem
          v-for="(item, itemKey) in $store.state.navigation.items"
          :content="item"
          :enter-delay="itemKey * 30"
          :key="itemKey"
        />
      </TransitionGroup>
      <div class="navbar__top-right">
        <LangRouterLink
          :to="{ name: $route.name ?? 'home', hash: '#contact' }"
          class="navbar__contact"
          title="Contact"
        >
          <span class="navbar__contact-label">Contact</span>
          <Icon id="mail" />
        </LangRouterLink>
        <LangSwitchLink class="navbar__contact --secondary" v-if="mq.mnPlus" />
        <button
          :class="['navbar__hamburger', { '--open': isOpen }]"
          @click="isOpen = !isOpen"
          v-if="mq.mdMinus"
          :title="isOpen ? $t('close') : $t('open')"
        >
          <span v-for="index in 3" :key="index"></span>
        </button>
      </div>
    </nav>
    <TransitionGroup
      name="nav-item-transition"
      tag="nav"
      class="navbar__bottom"
      v-if="mq.mdMinus"
      appear
    >
      <MobileMenuItem
        v-for="(item, itemKey) in $store.state.navigation.items"
        :content="item"
        :enter-delay="itemKey * 30"
        :key="itemKey"
      />
      <LangSwitchLink
        mode="long"
        class="navbar__bottom-item --short"
        :style="navItemStyle($store.state.navigation.items.length)"
        key="lang-switch"
      />
    </TransitionGroup>
    <Transition name="category-menu-transition">
      <CategoryMenu
        v-if="mq.mnPlus && $store.state.navigation.category"
        :category="$store.state.navigation.category"
      />
    </Transition>
  </header>
</template>

<script>
import { Icon, LangRouterLink } from '@/components/global'
import CategoryMenu from '@/components/navigation/CategoryMenu.vue'
import DesktopMenuItem from '@/components/navigation/DesktopMenuItem.vue'
import LangSwitchLink from '@/components/navigation/LangSwitchLink.vue'
import MobileMenuItem from '@/components/navigation/MobileMenuItem.vue'
import { bodyHelpers } from '@/helpers/bodyLockHelpers.js'

export default {
  name: 'SiteNav',
  inject: ['mq'],
  components: {
    CategoryMenu,
    DesktopMenuItem,
    Icon,
    LangRouterLink,
    LangSwitchLink,
    MobileMenuItem,
  },
  data() {
    return {
      isOpen: false,
    }
  },
  watch: {
    isOpen() {
      if (this.isOpen) {
        bodyHelpers.lock()
      } else {
        bodyHelpers.unlock()
      }
    },
    $route() {
      if (this.isOpen) this.isOpen = false
      this.$store.dispatch('updateActiveCategory', null)
    },
  },
  mounted() {
    window.addEventListener('resize', () => {
      if (window.innerWidth > 1249) this.isOpen = false
    })
  },
  methods: {
    navItemStyle(index) {
      return { '--nav-item-delay': `${index * 30}ms` }
    },
  },
}
</script>
